<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>FILTRAR DATOS DE VENTAS</span>
    </div>
    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="filters_aux.office_id"
              :items="offices_aux"
              label="Sucursal"
              hide-details
              outlined
              :item-text="customText"
              item-value="id"
              clearable
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="filters_aux.customer_id"
              :items="customers"
              label="Seleccione cliente"
              outlined
              :item-text="customTextCustomer"
              v-on:keyup.enter="searchCustomer($event)"
              item-value="id"
              :loading="searching"
              clearable
              hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="filters_aux.type_document"
              :items="type_documents"
              label="Documento"
              outlined
              clearable
              hide-details
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-menu
              v-model="menuFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filters_aux.date_from"
                  label="Desde"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters_aux.date_from"
                @input="menuFrom = false"
                no-title
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-menu
              v-model="menuUntil"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filters_aux.date_until"
                  label="Hasta"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters_aux.date_until"
                @input="menuUntil = false"
                no-title
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="filters_aux.product_id"
              :items="products"
              label="Producto"
              outlined
              :item-text="customTextProduct"
              v-on:keyup.enter="searchProduct($event)"
              item-value="id"
              :loading="searchingProduct"
              clearable
              hide-details
            ></v-autocomplete>
            <!-- <v-autocomplete
              v-model="filters_aux.product_id"
              :items="products"
              label="Producto"
              outlined
              item-text="description"
              item-value="product_id"
              clearable
              hide-details="auto"
              :loading="isLoading"
              :search-input.sync="search_product"
              hide-no-data
              hide-selected
              placeholder="Ingrese el producto a buscar"
            ></v-autocomplete> -->
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn
              block
              height="40"
              dark
              color="red"
              @click="handleClearFilters"
            >
              <v-icon size="16" class="mr-1">far fa-trash-alt</v-icon>
              Quitar filtros
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn dark color="blue" block height="40" @click="handleSearch">
              <v-icon size="16" class="mr-1">fas fa-search</v-icon>
              Filtrar datos
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

import InventoryApi from "../../apis/Inventories";

export default {
  name: "SalesFilters",
  data() {
    return {
      drawer: false,
      menuFrom: false,
      menuUntil: false,
      type_documents: ["TICKET", "BOLETA", "FACTURA"],
      isLoading: false,
      search_product: null,
      searching: false,
      searchingProduct: false,
      filters_aux: {},
      offices_aux: [],
    };
  },
  computed: {
    ...mapState("authentication", ["company_id", "office_id"]),
    ...mapState("customers", ["customers"]),
    ...mapState("sedes", ["sedes"]),
    ...mapState("offices", ["offices"]),
    ...mapState("saleoptions", ["sale_options"]),
    ...mapState("report-sales", ["filters", "optionsAux"]),
    ...mapState("products", ["products"]),
  },
  // watch: {
  //   async search_product(value) {
  //     if (value == null || value == undefined || value.length == 0) {
  //       return;
  //     }

  //     if (this.products.length > 0) {
  //       return;
  //     }

  //     if (this.isLoading) return;

  //     this.isLoading = true;

  //     let filters = {
  //       description: value,
  //     };
  //     InventoryApi.getProductsFromOffice(filters)
  //       .then((response) => {
  //         this.products = response.data;
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       })
  //       .finally(() => (this.isLoading = false));
  //   },
  // },
  methods: {
    ...mapActions("offices", ["getOffices", "run_set_offices"]),
    ...mapActions("report-sales", ["getSales", "setFilters", "setOptionsAux"]),
    ...mapActions("customers", ["getCustomers"]),
    ...mapActions("products", ["getProducts"]),

    show() {
      // this.filters.company_id = this.company_id;
      this.filters_aux = { ...this.filters };

      this.drawer = !this.drawer;
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    customTextCustomer(item) {
      let text = item.fullname;

      return text;
    },
    customTextProduct(item) {
      let text = item.name;

      return text;
    },
    closeForm() {
      this.drawer = false;
    },
    clearData() {
      this.filters_aux = {
        company_id: null,
        sede_id: null,
        office_id: null,
        type_document: null,
        modality: null,
        date_from: this.$moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        date_until: this.$moment().format("YYYY-MM-DD"),
        customer_id: null,
        product_id: null,
      };
      this.setFilters(this.filters_aux);
      this.setOptionsAux({ page: 1, itemsPerPage: 10 });
      this.menuFrom = false;
      this.menuUntil = false;
    },
    handleClearFilters() {
      this.clearData();
      this.getSales(this.filters);
    },
    async handleSearch() {
      let filters_data = Object.assign({}, this.filters_aux);

      this.setFilters(filters_data);
      const paginatedAux = { ...filters_data };
      let filterForSales = { ...this.filters, ...paginatedAux };
      if (filterForSales.office_id == -1) filterForSales.office_id = null;
      await this.getSales(filterForSales);
      this.closeForm();
    },
    async searchCustomer(event) {
      this.searching = true;
      const value = event.target.value;
      if (value.length > 0) {
        if (!isNaN(value)) {
          await this.getCustomers({ document: value });
        } else {
          await this.getCustomers({ fullname: value });
        }
      } else {
        await this.getCustomers();
      }
      this.searching = false;
    },
    async searchProduct(event) {
      this.searchingProduct = true;
      const value = event.target.value;
      if (value.length > 0) {
        await this.getProducts({ name: value, office_id: this.office_id });
        // if (!isNaN(value)) {
        //   await this.getProducts({ document: value });
        // } else {
        // }
      } else {
        await this.getProducts();
      }
      this.searchingProduct = false;
    },
  },
  created() {
    this.filters_aux = { ...this.filters };
    this.offices_aux = [...this.offices, { id: -1, name: "TODAS" }];
    // this.filters.office_id = this.office_id;
  },
};
</script>
